import * as Icons from '@/components/Common/Icons';
import { SvgIcons } from '@/types/types';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: SvgIcons;
}

export default function Icon({ name, ...props }: IconProps) {
  const ComponentName = Icons[name];
  if (!ComponentName) {
    console.warn(`Icon component for name "${name}" not found.`);
    return null;
  }
  return <ComponentName {...props} />;
}
